// app/providers.js
"use client";

import { c as _c } from "react/compiler-runtime";
import posthog from "posthog-js";
import "posthog-js/dist/exception-autocapture";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";
import { beforeSendToPostHog } from "@/lib/posthog-before-send";

// Preserve early upload events while initialization yields to the first render.
const pendingEvents: Array<() => void> = [];
const analyticsClient = new Proxy(posthog, {
  get(target, property) {
    if (property === "capture" || property === "captureException") {
      return (...args: unknown[]) => {
        const deliver = () => Reflect.apply(target[property], target, args);
        if (target.__loaded) return deliver();
        if (pendingEvents.length < 100) pendingEvents.push(deliver);
      };
    }
    return Reflect.get(target, property);
  }
});
export function CSPostHogProvider(t0) {
  const $ = _c(5);
  const {
    children,
    bootstrapData
  } = t0;
  let t1;
  if ($[0] !== bootstrapData) {
    t1 = () => {
      const initialize = () => {
        if (posthog.__loaded) {
          return;
        }
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
          api_host: "/ingest",
          ui_host: "https://eu.i.posthog.com",
          bootstrap: bootstrapData,
          before_send: beforeSendToPostHog,
          capture_pageview: false,
          capture_pageleave: true,
          debug: false,
          loaded: _temp2
        });
      };
      if ("requestIdleCallback" in window) {
        const id = window.requestIdleCallback(initialize, {
          timeout: 1000
        });
        return () => window.cancelIdleCallback(id);
      }
      const id_0 = setTimeout(initialize, 0);
      return () => clearTimeout(id_0);
    };
    $[0] = bootstrapData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <PostHogProvider client={analyticsClient}>{children}</PostHogProvider>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2(posthog) {
  posthog.register({
    platform: "web"
  });
  pendingEvents.splice(0).forEach(_temp);
  window.dispatchEvent(new Event("guestgallery:posthog-loaded"));
}
function _temp(deliver) {
  return deliver();
}